export const ATTENDANCE_LOCATION_FILTER = 'attendance_location';
export const ATTENDANCE_DATE = 'attendance_date';
export const ATTENDANCE_POSITIONS_FILTER = 'attendance_positions';
